import { CustomerUser, User } from '@/core/entities';
import { UserFormModel } from './types';

export const initialUserFormModel = {
	firstName: '',
	lastName: '',
	roleId: '',
};

export const initialCustomerUserFormModel = {
	...initialUserFormModel,
	sites: [],
};

export const userFormModelFromUser = (user: User): UserFormModel => ({
	firstName: user.firstName,
	lastName: user.lastName,
	email: user.email,
	roleId: user.roleId,
});

export const userFormModelFromCustomerUser = (user: CustomerUser): UserFormModel => ({
	firstName: user.firstName,
	lastName: user.lastName,
	email: user.email,
	roleId: user.roleId,
	sites: user.sites.map((site) => site.id),
});
